import React, { useMemo } from "react";

import type { TableInstance } from "react-table";
import { TableRow, TableBody } from "@material-ui/core";
import type { LoadingProps } from "../Loading";
import { Loading } from "../Loading";

import { useTableStyles } from "./TableStyles";

type TableLoadingIndicatorProps<T extends object> = LoadingProps & {
    instance: TableInstance<T>;
};

export const TableLoadingIndicator = <T extends object>(props: TableLoadingIndicatorProps<T>) => {
    const classes = useTableStyles();
    const { instance, ...loadingProps } = props;

    const bodyRootClass = useMemo(
        () => (instance.plugins.some((p) => p.pluginName.includes("FlexLayout")) ? classes.flexRoot : ""),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [instance],
    );

    return (
        <TableBody component="div" className={bodyRootClass}>
            {(loadingProps.isLoading !== undefined || loadingProps.keepMounted) && (
                <TableRow component="div">
                    <div className={classes.tableLoadingIndicatorRowContainer}>
                        <Loading {...loadingProps} className={classes.tableLoadingIndicatorRowContainerLoading} />
                    </div>
                </TableRow>
            )}
        </TableBody>
    );
};
